"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6666],{

/***/ 6666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Blocks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./functions/wordpress/blocks/displayBlock.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// Import WP blocks using Next Dynamic Imports
// @see https://nextjs.org/docs/advanced-features/dynamic-import
/**
 * Decide which block component to display.
 *
 * @author WebDevStudios
 * @param  {object}  block The block data.
 * @param  {number}  index A unique key required by React.
 * @return {Element}       A block-based component.
 */ function displayBlock(block, index) {
    var attributes = block.attributes, name = block.name, innerBlocks = block.innerBlocks, originalContent = block.originalContent, dynamicContent = block.dynamicContent;
    // prettier-ignore
    switch(name){
        /* -- CORE BLOCKS -- */ case 'core/button':
            {
                var BlockButton = (0,dynamic["default"])(function() {
                    return Promise.all(/* import() */[__webpack_require__.e(5536), __webpack_require__.e(4086)]).then(__webpack_require__.bind(__webpack_require__, 69556));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(69556)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockButton, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/buttons':
            {
                var BlockButtons = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 2355).then(__webpack_require__.bind(__webpack_require__, 62355));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(62355)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockButtons, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    key: index
                })));
            }
        case 'core/code':
        case 'core/preformatted':
            {
                var BlockCode = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 4203).then(__webpack_require__.bind(__webpack_require__, 34203));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(34203)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockCode, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/columns':
            {
                var BlockColumns = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 9637).then(__webpack_require__.bind(__webpack_require__, 29637));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(29637)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockColumns, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    key: index
                })));
            }
        case 'core/cover':
            {
                var BlockCover = (0,dynamic["default"])(function() {
                    return Promise.all(/* import() */[__webpack_require__.e(5536), __webpack_require__.e(109)]).then(__webpack_require__.bind(__webpack_require__, 70180));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(70180)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockCover, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    key: index
                })));
            }
        case 'core/embed':
            {
                var BlockEmbed = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 9837).then(__webpack_require__.bind(__webpack_require__, 49837));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(49837)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockEmbed, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/gallery':
            {
                var BlockImageGallery = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 6433).then(__webpack_require__.bind(__webpack_require__, 6433));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(6433)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockImageGallery, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/heading':
            {
                var BlockHeadings = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 7005).then(__webpack_require__.bind(__webpack_require__, 7005));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(7005)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockHeadings, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/image':
            {
                var BlockImage = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 7417).then(__webpack_require__.bind(__webpack_require__, 87417));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(87417)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockImage, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/list':
            {
                var BlockList = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 7825).then(__webpack_require__.bind(__webpack_require__, 97825));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(97825)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockList, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/media-text':
            {
                var BlockMediaText = (0,dynamic["default"])(function() {
                    return Promise.all(/* import() */[__webpack_require__.e(5536), __webpack_require__.e(9194)]).then(__webpack_require__.bind(__webpack_require__, 66922));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(66922)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockMediaText, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    key: index
                })));
            }
        case 'core/paragraph':
            {
                var BlockParagraph = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 919).then(__webpack_require__.bind(__webpack_require__, 70919));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(70919)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockParagraph, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/pullquote':
            {
                var BlockPullQuote = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 1255).then(__webpack_require__.bind(__webpack_require__, 21255));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(21255)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockPullQuote, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/quote':
            {
                var BlockQuote = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 5122).then(__webpack_require__.bind(__webpack_require__, 65122));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(65122)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockQuote, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/separator':
            {
                var BlockSeparator = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 254).then(__webpack_require__.bind(__webpack_require__, 80254));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(80254)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockSeparator, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/spacer':
            {
                var BlockSpacer = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 7150).then(__webpack_require__.bind(__webpack_require__, 87150));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(87150)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockSpacer, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/table':
            {
                var BlockTable = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 3788).then(__webpack_require__.bind(__webpack_require__, 23788));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(23788)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockTable, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        case 'core/html':
            {
                // const BlockHtml = dynamic(() => import('@/components/blocks/core/BlockHtml'))
                // return <BlockHtml {...attributes} key={index} />
                return (0,html_react_parser/* default */.ZP)(originalContent);
            }
        /* -- GRAVITY FORMS BLOCKS -- */ case 'gravityforms/form':
            {
                var BlockGravityForm = (0,dynamic["default"])(function() {
                    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(4231), __webpack_require__.e(8293)]).then(__webpack_require__.bind(__webpack_require__, 48293));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(48293)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(BlockGravityForm, _objectSpread({}, attributes, {
                    key: index
                })));
            }
        /* -- STACKABLE BLOCKS -- */ case 'stackable/feature':
            {
                var StkBlockFeature = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 2231).then(__webpack_require__.bind(__webpack_require__, 92231));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(92231)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockFeature, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/columns':
            {
                var StkBlockColumns = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 8100).then(__webpack_require__.bind(__webpack_require__, 28100));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(28100)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockColumns, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/column':
            {
                var StkBlockColumn = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 575).then(__webpack_require__.bind(__webpack_require__, 40575));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(40575)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockColumn, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/button-group':
            {
                var StkBlockButtonGroup = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 3035).then(__webpack_require__.bind(__webpack_require__, 43035));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(43035)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockButtonGroup, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/call-to-action':
            {
                var StkBlockCallToAction = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 369).then(__webpack_require__.bind(__webpack_require__, 50369));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(50369)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockCallToAction, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/icon-box':
            {
                var StkBlockIconBox = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 4922).then(__webpack_require__.bind(__webpack_require__, 34922));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(34922)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockIconBox, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/icon-label':
            {
                var StkBlockIconLabel = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 7366).then(__webpack_require__.bind(__webpack_require__, 27366));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(27366)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockIconLabel, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/team-member':
            {
                var StkBlockTeamMember = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 4535).then(__webpack_require__.bind(__webpack_require__, 24535));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(24535)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockTeamMember, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/feature-grid':
            {
                var StkBlockFeatureGrid = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 8794).then(__webpack_require__.bind(__webpack_require__, 78794));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(78794)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockFeatureGrid, _objectSpread({}, attributes, {
                    innerBlocks: innerBlocks,
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/button':
            {
                var StkBlockButton = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 9661).then(__webpack_require__.bind(__webpack_require__, 89661));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(89661)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockButton, _objectSpread({}, attributes, {
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/image':
            {
                var StkBlockImage = (0,dynamic["default"])(function() {
                    return __webpack_require__.e(/* import() */ 451).then(__webpack_require__.bind(__webpack_require__, 60451));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(60451)
                            ];
                        }
                    }
                });
                return(/*#__PURE__*/ (0,react.createElement)(StkBlockImage, _objectSpread({}, attributes, {
                    originalContent: originalContent,
                    key: index
                })));
            }
        case 'stackable/heading':
            return (0,html_react_parser/* default */.ZP)(originalContent);
        case 'stackable/subtitle':
            return (0,html_react_parser/* default */.ZP)(originalContent);
        case 'stackable/icon':
            return (0,html_react_parser/* default */.ZP)(originalContent);
        case 'stackable/text':
            return (0,html_react_parser/* default */.ZP)(originalContent.replace('https://sharqinsurance.web2box.com/wp-content', 'https://s3.eu-west-1.amazonaws.com/web2box.com'));
        case 'stackable/icon-list':
            return (0,html_react_parser/* default */.ZP)(originalContent.replace(new RegExp('https:\\/\\/sharqinsurance\\.web2box\\.com\\/wp-content', 'gi'), 'https://s3.eu-west-1.amazonaws.com/web2box.com'));
        case 'stackable/number-box':
            return (0,html_react_parser/* default */.ZP)(originalContent);
        default:
            return (0,html_react_parser/* default */.ZP)(dynamicContent);
    }
};
displayBlock.propTypes = {
    block: (prop_types_default()).object.isRequired,
    index: (prop_types_default()).number.isRequired
};

;// CONCATENATED MODULE: ./components/molecules/Blocks/Blocks.js




/**
 * Render the Blocks component.
 *
 * @author WebDevStudios
 * @param  {object}  props        The component attributes as props.
 * @param  {Array}   props.blocks The array of blocks.
 * @return {Element}              The Blocks component.
 */ function Blocks(param) {
    var blocks = param.blocks;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: // If there are blocks, loop over and display.
        !!(blocks === null || blocks === void 0 ? void 0 : blocks.length) && blocks.map(function(block, index) {
            return displayBlock(block, index);
        })
    }));
};
Blocks.propTypes = {
    blocks: (prop_types_default()).array.isRequired
};
Blocks.defaultProps = {
    blocks: []
};

;// CONCATENATED MODULE: ./components/molecules/Blocks/index.js



/***/ })

}]);